export const CUSTOMER_NAME = (globalThis as any).RUNTIME_CONFIG?.CUSTOMER_NAME ?? 'CANCOM BUDSAI';

// Test mode is opt-in per session via the ``?test=1`` query parameter, so normal
// users never see the load-simulation controls.
export const TEST_MODE = (() => {
  const raw = new URLSearchParams(window.location.search).get('test');
  return raw != null && /^(1|true|yes|on)$/i.test(raw);
})();
